import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { required } from "../../../util/validators";
import { ImportModal } from "../../components/ImportModal";

export const ImportPayorsModal = ({ onImport, policyId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      policyId: values.policyId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/policies/${policyId}/import_payors`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Add Payors to Policy from CSV..."
      initialValues={{ policyId }}
      exampleDownloadPath="/admin/policies/import_payors_example_csv"
    >
      {(formProps) => <Field component={TextInput} name="policyId" type="hidden" required validate={required} />}
    </ImportModal>
  );
};
